// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/in-flight-log.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/in-flight-log/flight-following.js';
import g1 from '../lessons/navigation/in-flight-log/in-flight-log.js';

mount([g0, g1]);
